<template>
  <v-card class="inflated-mark">
    <v-subheader>
      <v-icon medium color="purple lighten-1" class="mr-2">handshake</v-icon>
      <span class="ml-2">Завысил оценку для <a :href="userProfileBaseUrl + '/u/' + examinee.uid" target="_blank">{{ examinee.name }} {{ examinee.surname }}</a> на {{ level }} уровне за задание {{ task }}</span>
    </v-subheader>
  </v-card>
</template>

<script>
import {urls} from "@/config";

export default {
  name: "InflatedMark",
  props: ["examinee", "level", "task"],
  data () {
    return {
      userProfileBaseUrl: urls.signin
    }
  }
}
</script>

<style scoped>
.inflated-mark {
  border: 1px solid #78909C;
}

</style>
